<template>
  <view class="content"> 

    <BottomTabBar active="progress" />
     <web-view :src="url"></web-view>
  </view>
</template>

<script>
import BottomTabBar from '@/components/BottomTabBar.vue'
import LogTimeLine from '@/components/log-time-line.vue'

export default {
  name: 'TaskProcess',
  components: { BottomTabBar, LogTimeLine },
  data() {
    return {
      url:'',
    }
  },
  onLoad(query) {
    // 封装解码工具函数
    const decodeValue = (value) => {
      if (typeof value !== 'string' || value === '') return '';
      try {
        return decodeURIComponent(value);
      } catch (e) {
        console.error('参数解码失败：', e, '原始值：', value);
        return value;
      }
    };
    // 需要拼接必要的参数 来通过验证 
    let token = uni.getStorageSync('token') || '';
    const isView = query.isView === 'true' || query.isView === true;
    const pageName = isView ? 'web-view-entry' : 'web-view-send';
    this.url = `http://192.168.0.2/${pageName}?token=${token}`;


    let deployId = 'deployId=' + decodeValue(query.deployId)

    let taskId = 'taskId=' + decodeValue(query.taskId)

    let procInsId = 'procInsId=' + decodeValue(query.procInsId)
    
    let projectName = 'projectName=' + decodeValue(query.projectName)

    let flowName = 'flowName=' + decodeValue(query.flowName)
   
    let processName = 'processName=' + decodeValue(query.processName)

    console.log(deployId, taskId, procInsId, projectName, flowName, processName)
    this.url += '&'+ deployId + '&' + taskId + '&' + procInsId + '&' + projectName + '&' + flowName + '&' + processName;
    console.log(this.url)
  },
  methods: {

    /**
     * 返回上一页
     */
    handleBack() {
      uni.navigateBack();
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f7fa;
  padding-bottom: 120rpx;
}


</style>